<template>
    <v-select
        label="Escolha o Departamento"
        :items="items"
        :loading="loadingValue"
        :disabled="isDisabled"
        :dark="dark"
        class="ma-0"
        v-model="internalValue"
    />
</template>

<script>
import { getServicoContexto } from "../../services/ServicosFactory";
import { mapState } from "vuex";

const servicoContexto = getServicoContexto();

export default {
    name: "caixa-contexto",
    props: ["value", "dark"],
    data: () => {
        return {
            contextos: [],
            loading: true,
            internalValue: null,
        };
    },
    mounted() {
        this.atualizarContextos();
    },
    methods: {
        atualizarContextos() {
            servicoContexto
                .obterContextosHabilitados()
                .then((data) => {
                    this.contextos = data;
                    this.loading = false;
                    if (data.length === 1) {
                        const contextoSalvoValido =
                            this.value != null &&
                            data.some((c) => c.sigla === this.value.sigla);
                        if (!contextoSalvoValido) {
                            this.$emit("input", data[0]);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$router.push({ name: "500" });
                });
        },
    },
    computed: {
        items: function () {
            return this.contextos.map((contexto) => {
                return {
                    text: contexto.sigla,
                    value: contexto,
                };
            });
        },
        loadingValue: function () {
            if (this.isLoading) {
                return "white";
            } else {
                return false;
            }
        },
        isDisabled() {
            return this.loading || !!this.contextoPendente;
        },

        isLoading() {
            return this.loading || !!this.contextoPendente;
        },
        ...mapState("contexto", ["contextoPendente"]),
    },
    watch: {
        value: {
            immediate: true,
            handler(novo) {
                this.internalValue = novo;
            },
        },
        internalValue(novo) {
            if (novo !== this.value && !this.contextoPendente) {
                this.$emit("input", novo);
            }
        },
        contextoPendente(novo) {
            if (novo == null) {
                this.internalValue = this.value;
            }
        },
    },
};
</script>
